import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { navigateInternally, splitQueryAndPath } from 'utils/bolt/index';
import { smoothScrollTo } from 'utils/smoothScroll';
import Button from 'components/bolt/button/button';
import HubTextOverlay from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay';
import { getCopy } from 'utils/copy';
import s from 'components/bolt/hub/components/buttons/buttons.sss';

export default class Buttons extends Component {

	componentDidMount() {
		this.iframe = document.querySelector('iframe');
		this.buttonSrc = this.iframe?.src;
	}

	onLinkClick() {}

	triggerAction(path, label, sameWindow, videoOverlay, textOverlay, btnIndex) {
		const { isHero } = this.props;

		if (isHero) {
			Store.emit('HUB_HERO_ENGAGEMENT_CTA_CLICKED', { buttonLabel: label, destination: path });
		}
		// else {
		// 	Store.emit('HUB_CAROUSEL_ENGAGEMENT_TILE_CLICKED', { carouselTitle: carouselTitle, tileTitle: filmTitle, destination: path });
		// 	Store.emit('HUB_CAROUSEL_ENGAGEMENT_CTA_CLICKED', { carouselTitle: carouselTitle, tileTitle: filmTitle, buttonLabel: label, destination: path });
		// }

		if (textOverlay) {
			this.toggleTextOverlay(true, `button-${btnIndex}`);
			return;
		}

		if (path === 'scrollTop') {
			smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		} else if (videoOverlay) {
			Store.emit('ENABLE_TRAILER_OVERLAY', videoOverlay);
		} else {
			const mainScroll = document.getElementById('mainScroll');
			const logo = label.toLowerCase() === 'logo';
			let store = Store.get();
			const isRootPath = store.activePage?.path === '/';
			if (isRootPath && logo) {
				return smoothScrollTo(mainScroll, 0, 300);
			}
			// This should probably not be done here
			// Checking fully if the destination is a page or a custom value or a section in the current scroll etc. is quite complex
			// So any animation should probably happen after the page is changed instead (e.g. SET_ACTIVE_PAGE listener)
			// if (store.appData?.pages?.[path]) {
			// 	await animation(mainScroll, 'left', 400);
			// }

			const { query, path: splitPath } = splitQueryAndPath(path);
			navigateInternally(splitPath, { queryString: query });
		}
	}

	toggleTextOverlay(open, textOverlayId) {
		this.setState({
			[`textOverlay-${textOverlayId}-show`]: open
		});
		if (this.iframe) this.iframe.src = (open ? this.buttonSrc : '');
		Store.emit('CAROUSEL_TEXT_OVERLAY_SHOW', open ? this.props.carouselId : null);
	}


	renderTextOverlay(textOverlay, textOverlayId) {
		if (!textOverlay) return;
		const show = this.state[`textOverlay-${textOverlayId}-show`];

		return (
			<HubTextOverlay
				content={textOverlay}
				show={show}
				closeOverlay={() => this.toggleTextOverlay(false, textOverlayId)}
			/>
		);
	}

	renderBtn(btn, index) {
		let content = [
			<span class={joinClasses(s.btnCopy, 'largeB')}>{getCopy(btn.btnCopy) || btn.btnCopy}</span>,
			btn.icon && <img class={s.icon} src={btn.icon} alt="" />
		];
		if (/^(https?|mailto):/.test(btn.link)) {
			return (
				<a
					class={s.btn}
					href={btn.link}
					target={btn.sameWindow ? '_self' : '_blank'}
					ariaLabel={getCopy(btn.btnCopy) || btn.btnCopy}
					onClick={() => this.onLinkClick(btn)}
					rel="noopener noreferrer"
				>
					{content}
				</a>
			);
		}
		return (
			<Button
				class={s.btn}
				trigger={() => this.triggerAction(btn.link, btn.btnCopy, btn.sameWindow, btn.videoOverlay?.video, btn.textOverlay?.content, index)}
				ariaLabel={getCopy(btn.btnCopy) || btn.btnCopy}
			>
				{content}
			</Button>
		);
	}

	componentWillUnmount() {
		clearTimeout(this.goToTimeout);
	}

	render({ data, isHero, clientDimensions, buttonType }) {
		let buttons = sortObjectByOrder(data);
		let maxButtons = 2;
		if (isHero && clientDimensions.width >= 768) {
			maxButtons = 3;
		}
		buttons = buttons.slice(0, maxButtons);

		return (
			<div class={!this.props.heroButtons && joinClasses(s.row, s[buttonType], isHero && s.heroRow)}>
				{buttons.length > 0 && buttons.map((btn, i) => this.renderBtn(btn, i))}
				{buttons.length > 0 && buttons.map((btn, i) => this.renderTextOverlay(btn?.textOverlay?.content, `button-${i}`))}
			</div>
		);
	}
}
